import { Field, useFormikContext } from 'formik'
import React from 'react'

import { useDashboardFeatureFlags } from '@components'
import { Checkbox, Fieldset, Subsection } from '@fourthwall/components'

import type { FieldValues, FormValues } from '../../EmailNotifications.types'

export const Memberships = () => {
  const { values } = useFormikContext<FieldValues>()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  if (!dashboardFeatureFlags.memberships.enabled) return null

  return (
    <Subsection title="Memberships">
      <Fieldset>
        <Fieldset.Row>
          <Fieldset.Item>
            <Field
              component={Checkbox}
              name={'newMembers' satisfies FormValues}
              label="New members"
              description="Notify me when new members join"
            />
          </Fieldset.Item>
        </Fieldset.Row>
        <Fieldset.Row>
          <Fieldset.Item>
            <Field
              component={Checkbox}
              name={'newPostComments' satisfies FormValues}
              label="New post comments"
              description="Notify me about new comments under my posts"
            />
          </Fieldset.Item>
        </Fieldset.Row>
        {values.newPostComments && (
          <Fieldset.Row inner>
            <Fieldset.Item>
              <Field
                component={Checkbox}
                name={'newPostCommentsReply' satisfies FormValues}
                label="Only replies to my comments"
              />
            </Fieldset.Item>
          </Fieldset.Row>
        )}
        {dashboardFeatureFlags.membershipsMessages.enabled && (
          <>
            <Fieldset.Row>
              <Fieldset.Item>
                <Field
                  component={Checkbox}
                  name={'newDirectMessage' satisfies FormValues}
                  label="New messages from members"
                  description="Notify me when a member sends me a private message"
                />
              </Fieldset.Item>
            </Fieldset.Row>
            {values.newDirectMessage && (
              <Fieldset.Row inner>
                <Fieldset.Item>
                  <Field
                    component={Checkbox}
                    name={'newDirectMessageWithTip' satisfies FormValues}
                    label="Only notify me if the message includes a tip"
                  />
                </Fieldset.Item>
              </Fieldset.Row>
            )}
            <Fieldset.Row>
              <Fieldset.Item>
                <Field
                  component={Checkbox}
                  name={'messageUnlocks' satisfies FormValues}
                  label="Message unlocks"
                  description="Notify me when a message is unlocked"
                />
              </Fieldset.Item>
            </Fieldset.Row>
          </>
        )}
      </Fieldset>
    </Subsection>
  )
}
